const cacheableResources = [{
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/modules/api-interface/index.js`,
  priority: 1
}, {
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/components/application/user-profile-editor/index.js`,
  priority: 1
}, {
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/modules/dialogs-manager/index.js`,
  priority: 1
}, {
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/modules/prompts/index.js`,
  priority: 1
}, {
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/components/core/vertical-sections/index.js`,
  priority: 1
}, {
  url: `${import.meta.env.REACT_APP_BROWSER_COMPONENTS_BASE_ADDRESS}/components/core/dialog-header/index.js`,
  priority: 1
}];

export default cacheableResources.sort(function sorter(r1, r2) {
  return r1.priority - r2.priority;
});